export default __webpack_public_path__ + "static/media/SL.8897f902.ico";